import { Td, Flex, Text } from "@chakra-ui/react";
import { TableColumn } from "./types";
import { truncateText } from "./utils";

interface TableCellProps {
  column: TableColumn<any>;
  item: any;
  onPinToggle?: (item: any) => void;
}

const TableCell = ({ column, item }: TableCellProps) => {
  const content = column.render ? (
    column.render(item[column.key], item)
  ) : (
    <Text fontSize="sm">{truncateText(item[column.key]?.toString())}</Text>
  );

  return (
    <Td>
      <Flex align="center">{content}</Flex>
    </Td>
  );
};

export default TableCell;
